import { z } from 'zod';
function sizeMessage(issue) {
    const small = issue.code === 'too_small';
    const n = Number(small ? issue.minimum : issue.maximum);
    switch (issue.origin) {
        case 'string':
            if (small && n <= 1)
                return 'Kjo fushë duhet plotësuar.';
            return small
                ? `Shkruani të paktën ${n} shkronja.`
                : `Mund të shkruani deri në ${n} shkronja.`;
        case 'array':
        case 'set':
            return small ? `Zgjidhni të paktën ${n}.` : `Mund të zgjidhni deri në ${n}.`;
        case 'number':
        case 'int':
        case 'bigint':
            return small
                ? `Vlera duhet të jetë të paktën ${n}.`
                : `Vlera duhet të jetë jo më shumë se ${n}.`;
        case 'date':
            return small ? 'Data është shumë e hershme.' : 'Data është shumë e vonë.';
        default:
            return 'Vlera nuk është e saktë.';
    }
}
export function albanianError(issue) {
    switch (issue.code) {
        case 'invalid_type': {
            if (issue.input === undefined || issue.input === null)
                return 'Kjo fushë duhet plotësuar.';
            const expected = issue.expected;
            if (expected === 'number' || expected === 'int')
                return 'Shkruani një numër.';
            if (expected === 'date')
                return 'Zgjidhni një datë të saktë.';
            return 'Vlera nuk është e saktë.';
        }
        case 'too_small':
        case 'too_big':
            return sizeMessage(issue);
        case 'invalid_format': {
            const format = issue.format;
            if (format === 'email')
                return 'Adresa e emailit nuk duket e saktë.';
            if (format === 'uuid' || format === 'guid')
                return 'Zgjidhni një vlerë nga lista.';
            if (format === 'url')
                return 'Adresa e internetit nuk duket e saktë.';
            return 'Formati nuk është i saktë.';
        }
        case 'not_multiple_of':
            return 'Shkruani një numër të plotë.';
        case 'invalid_value':
            return 'Zgjidhni një nga vlerat e lejuara.';
        default:
            return 'Vlera nuk është e saktë.';
    }
}
z.config({ localeError: albanianError });
//# sourceMappingURL=zod-sq.js.map